import { useMutation, useQueryClient } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type { User } from '../model/types';

export const createUserAPI = async (
  roleId: string,
  user: User,
  ghlUserId?: string,
) => {
  const response = await baseAPI.post<Array<User>>(`/users`, {
    roleId,
    ...user,
    ghlUserId,
  });
  return response.data;
};

export const useCreateUser = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      roleId,
      user,
      ghlUserId,
    }: {
      roleId: string;
      user: User;
      ghlUserId?: string;
    }) => createUserAPI(roleId, user, ghlUserId),
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: [KEYS.USERS] }),
        queryClient.invalidateQueries({
          queryKey: [KEYS.UNLINKED_CRM_USERS],
        }),
      ]);
    },
  });
};
